import { useMutation, UseMutationOptions } from 'react-query';
import { request } from 'src/helpers/request';
import { AuthEndpoint } from 'src/services/endpoints';

export type LogoutQueryOptions = UseMutationOptions;

export function useLogoutQuery(options?: UseMutationOptions) {
  return useMutation('logout', (params) => request.get(AuthEndpoint.logout).then((res) => res.data), options);
}
